import script from "./BlogPostDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostDetailView.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostDetailView.vue?vue&type=style&index=0&id=0d225ff3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d225ff3"]])

export default __exports__